export default "__VITE_ASSET__De$GFt1Q__"